import { Capacitor, registerPlugin } from "@capacitor/core";

export type NativeClerkUser = {
  userId: string | null;
  isSignedIn: boolean;
  firstName?: string | null;
  lastName?: string | null;
  imageUrl?: string | null;
  emailAddress?: string | null;
};

type NativeClerkPlugin = {
  configure: (options: { publishableKey: string }) => Promise<void>;
  startHostedAuth: () => Promise<NativeClerkUser>;
  getToken: () => Promise<{ token: string | null }>;
  getUser: () => Promise<NativeClerkUser>;
  isSignedIn: () => Promise<{ isSignedIn: boolean }>;
  signOut: () => Promise<void>;
};

export const NativeClerk = registerPlugin<NativeClerkPlugin>("NativeClerk");

export const configureNativeClerk = async () => {
  if (Capacitor.getPlatform() !== "ios") {
    return;
  }

  const publishableKey = process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY;

  if (!publishableKey) {
    throw new Error("NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY is not configured");
  }

  await NativeClerk.configure({ publishableKey });
};
